import React, { useEffect, useState, useRef } from 'react';
import { Image } from 'react-bootstrap';
import { ChromePicker } from 'react-color';
import { useToast } from '../hooks/toast';

import SelectionConfirmedIcon from '../assets/icon/selectionConfirmed.svg';
import AddImageIcon from '../assets/icon/addImage.svg';
import SelectColorIcon from '../assets/icon/selectColor.svg';

import api from '../services/apiClient';

interface ListImageProps {
  // colors: string[];
  backgroundImages: string[];
  backgroundColor: string;
  setBackgroundColor: (color: string) => void;
  backgroundImage: string;
  setBackgroundImage: (color: string) => void;
  positionShow: string;
  enable?: boolean;
  changeColor?: boolean;
  addNewImage: (image: string) => void;
}

const ListImage = ({
  // colors,
  backgroundImages,
  backgroundColor,
  setBackgroundColor,
  backgroundImage,
  setBackgroundImage,
  positionShow,
  enable,
  changeColor,
  addNewImage,
}: ListImageProps): JSX.Element => {
  const [showColor, setShowColor] = useState(false);
  const refInputImage = useRef<HTMLInputElement>(null);
  const { addToast } = useToast();

  const handleImageChange = (e: any): void => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append(`file[0]`, file);

    const token = localStorage.getItem('@LiveChat:token');

    api
      .post(`/api/Imagem/Background`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((request) => {
        const { success, data } = request.data;

        if (success) {
          if (data !== '') {
            addNewImage(data);
            setBackgroundImage(data);
            setBackgroundColor('');
          }
        }
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Falha ao enviar arquivo',
        });
      });
  };

  const handleClick = (image: string): void => {
    if (image) {
      setBackgroundImage(image);
    } else {
      setBackgroundImage('');
    }
  };

  return (
    <div className="d-flex position-relative">
      {backgroundImages.map((image, index) => (
        <div key={image}>
          {(backgroundImage === image ||
            (backgroundImage === '' &&
              index === backgroundImages.length - 1)) && (
            <Image
              src={SelectionConfirmedIcon}
              alt="Cor Selecionada"
              className="position-absolute"
              style={{
                width: '1.5rem',
                height: '1.5rem',
                marginLeft: '3rem',
                marginTop: '3rem',
              }}
            />
          )}
          <div
            role="button"
            tabIndex={0}
            aria-label="Select red color"
            style={{
              background: ((): string => {
                if (!image && !backgroundColor) {
                  return '#D1D1D1';
                }
                if (!backgroundColor || index !== backgroundImages.length - 1) {
                  return `url('${process.env.REACT_APP_API_URL}/BackGroundImage/${image}') no-repeat center/100% 100%, linear-gradient(108deg, #FFF 0%, #A9C4D8 100%)`;
                }
                return backgroundColor;
              })(),
              marginRight: '1rem',
              borderRadius: '0.6875rem',
              border: '1px #828282 solid',
              width: '4rem',
              height: '4rem',
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleClick(image);
              }
            }}
            onClick={() => {
              handleClick(image);
            }}
          />
        </div>
      ))}

      <div
        style={{
          width: '4rem',
          height: '4rem',
        }}
        role="button"
        tabIndex={0}
        aria-label="Add image"
        onClick={() => refInputImage.current?.click()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') refInputImage.current?.click();
        }}
      >
        <Image
          src={AddImageIcon}
          alt="Adicionar imagem"
          className="w-100 h-100"
        />

        <input
          type="file"
          style={{ display: 'none' }}
          accept=".jpg,.jpeg,.png"
          onChange={handleImageChange}
          ref={refInputImage}
        />
      </div>

      {changeColor && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Select red color"
          onClick={() => setShowColor(!showColor)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') setShowColor(!showColor);
          }}
          style={{
            width: '31px',
            height: '30px',
            position: 'relative',
            marginLeft: '1rem',
          }}
        >
          <Image
            src={SelectColorIcon}
            style={{ width: '4rem', height: '4rem' }}
          />
        </div>
      )}

      {/* Exibe a paleta de cores para o usuário */}
      <div
        className={`position-absolute ${showColor ? 'd-block' : 'd-none'}`}
        style={{ top: '-4.2rem', left: `${positionShow}`, zIndex: 2 }}
      >
        <ChromePicker
          color={backgroundColor === null ? '#616161' : backgroundColor}
          onChange={(color) => {
            setBackgroundColor(color.hex);
            setBackgroundImage('');
          }}
        />
      </div>

      {/* Fecha a paleta de cores quando clicado fora do componente */}
      <div
        className={`${showColor ? 'd-block' : 'd-none'}`}
        onClick={() => setShowColor(!showColor)}
        onKeyDown={() => setShowColor(!showColor)}
        role="button"
        style={{
          top: '0',
          left: '0',
          position: 'fixed',
          height: '100vh',
          width: '100vw',
          zIndex: 1,
        }}
        tabIndex={0}
      >
        {' '}
      </div>
    </div>
  );
};

ListImage.defaultProps = {
  enable: true,
  changeColor: true,
};

export default ListImage;
